export default {
  transaction: {
    title: 'Transacción',
    select: 'Seleccionar',
    all: 'Todos',
    loading: 'Cargando...',
    noMoreData: 'No hay más datos',
    mockSuccess: 'Éxito simulado',
    mockFail: 'Fallo simulado',
    mockSuccessDone: 'Éxito simulado completado',
    mockFailDone: 'Fallo simulado completado',
    mockFailed: 'Simulación fallida',
    today: 'Hoy',
    yesterday: 'Ayer',
    last3Days: 'Últimos 3 días',
    last7Days: 'Últimos 7 días',
    last15Days: 'Últimos 15 días',
    last30Days: 'Últimos 30 días',
    allTypes: 'Todos los tipos',
    deposit: 'Depósito',
    withdrawal: 'Retiro',
    withdrawalRefund: 'Reembolso de retiro',
    bet: 'Apuesta',
    win: 'Ganancia',
    manualAdd: 'Adición manual',
    manualSubtract: 'Resta manual',
    commission: 'Comisión',
    bonus: 'Bonificación',
    vipUpgradeReward: 'Recompensa de mejora VIP',
    vipSalary: 'Salario VIP',
    gameOutPrincipal: 'Salida de juego - Principal',
    gameOutBonus: 'Salida de juego - Bonificación',
    bonusTransferOut: 'Transferencia de bonificación',
    allStats: 'Todos los estados',
    underReview: 'En revisión',
    pendingPayout: 'Pago pendiente',
    successful: 'Exitoso',
    failed: 'Falló',
    cancelled: 'Cancelado',
    processing: 'Procesando',
  },
};
